
import {tap} from 'rxjs/operators';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { LawService } from "../../services/law.service";
import { LoaderService } from "../../../common/services/loader.service";
import { Optional, Injectable } from "@angular/core";
import { Law } from "../../models/models";
import { NavService } from "../../services/nav.service";

@Injectable()
export class LawLibraryEditorResolver  {

    constructor(
        public _lawService: LawService,
        public _navService: NavService,
        @Optional() public _loader: LoaderService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Law> {
        if (!this._loader)
            return this._lawService.getLaw(route.parent.params.id)

        this._loader.toggleLoader(true);
        return this._lawService.getLaw(route.parent.params.id).pipe(tap(x => {
            this._navService.setActiveNavItem(x);
            this._loader.toggleLoader(false)
        }));
    }
}